import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ConversationsPage } from './pages/ConversationsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { Login } from './components/Login';
import { AuthProvider } from './context/AuthContext';
import { ReviewsProvider } from './context/ReviewsContext';
import { ConversationsProvider } from './context/ConversationsContext';
import { SystemNotesProvider } from './context/SystemNotesContext';
import { ToastProvider } from './components/ui/toast';
import './App.css';

function App() {
    return (
        <ToastProvider>
            <AuthProvider>
                <ReviewsProvider>
                    <ConversationsProvider>
                        <SystemNotesProvider>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/" element={<AppShell />} />
                                    <Route path="/app" element={<AppShell />} />
                                    <Route path="/conversations" element={<ConversationsPage />} />
                                    <Route path="/analytics" element={<AppShell><AnalyticsPage /></AppShell>} />
                                </Routes>
                            </BrowserRouter>
                        </SystemNotesProvider>
                    </ConversationsProvider>
                </ReviewsProvider>
            </AuthProvider>
        </ToastProvider>
    );
}

export default App;

